import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { MapPin, ArrowRight } from "@phosphor-icons/react";

export default function Cites() {
    const [groups, setGroups] = useState({});
    useEffect(() => {
        api.get("/clients/by-city").then((r) => setGroups(r.data));
    }, []);
    const cities = Object.keys(groups);

    return (
        <Layout>
            <div className="mb-8">
                <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-2">Cités</p>
                <h1 className="font-display text-4xl font-bold text-ink">Vue par cité</h1>
                <p className="text-ink-soft mt-2">Toutes les cités où vos clients ont acquis un terrain.</p>
            </div>

            {cities.length === 0 ? (
                <div className="bento-card text-center py-12 text-ink-soft">Aucune cité enregistrée.</div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {cities.map((c) => {
                        const list = groups[c];
                        const paid = list.filter((x) => x.is_fully_paid).length;
                        return (
                            <div key={c} className="bento-card fade-up" data-testid={`cite-card-${c}`}>
                                <div className="flex items-center justify-between">
                                    <div className="w-10 h-10 rounded-md bg-terracotta/10 text-terracotta grid place-items-center">
                                        <MapPin weight="duotone" size={20} />
                                    </div>
                                    <span className="text-xs uppercase tracking-widest text-ink-soft">
                                        {list.length} client{list.length > 1 ? "s" : ""}
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl font-bold text-ink mt-4">{c}</h3>
                                <div className="mt-3 text-sm text-ink-soft">
                                    {paid} soldé{paid > 1 ? "s" : ""} · {list.length - paid} en cours
                                </div>
                                <Link
                                    to={`/clients`}
                                    className="mt-4 inline-flex items-center gap-1 text-xs uppercase tracking-widest text-terracotta hover:underline"
                                >
                                    Voir les clients <ArrowRight size={14} />
                                </Link>
                            </div>
                        );
                    })}
                </div>
            )}
        </Layout>
    );
}
